import React from 'react'
import utils from '../../modules/utils.js'
import './cf_field.css'

class CodiceFiscaleField extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: "",
            error: ''
        }
        this.handleCF = this.handleCF.bind(this);
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.cf && nextProps.cf!="" && nextProps.cf !== this.state.value) {
        this.setState({ value: nextProps.cf });
      }
    }

    handleClick = (event) => {
        event.target.focus();
    }

    handleCF(event) {
        let field_value = event.target.value;
        let cur_error = '';
        let correct_format = utils.validateCF(field_value);
        if (!correct_format) {
            cur_error = 'Formato del codice fiscale non valido';
        }
        this.setState({
            'error': cur_error,
            'value': field_value ? field_value.toUpperCase() : ""
        });
    }
    render() {
        return (
            <div className={'fiscale inputContainer ' + (this.state.error == '' && this.state.value != '' ? 'valid' : '') + ' ' + (this.state.error != '' && this.state.value != '' ? 'notValid' : '') + ' ' + (this.state.value != '' ? 'filled' : '')}>
                <input type="text" name={ this.props.name } onClick={this.handleClick} onChange={this.handleCF} value={ this.state.value } id="cf_field" />
                <label>Inserisci il Codice Fiscale</label>
                <div className="error">{this.props.error}</div>
                <div className="icon">
                  <img src="./img/check.png" alt="Verificato" />
                </div>
            </div>
        );
    }
}

export default CodiceFiscaleField


// WEBPACK FOOTER //
// ./src/components/shared/cf_field.js